module.exports = __webpack_public_path__ + "hbomaxar-static/media/LiquidTrip_Transition_00097.fc3613bc.png";